function configureGeolocation(opts) {
  void opts.replicantClientPromise.then(async (replicant) => {
    const geolocation = replicant.getGeolocation();
    if (geolocation) {
      opts.gcinstant.setCountry(geolocation.country);
    }
  });
}
export {
  configureGeolocation
};
